import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import FetchHook from "../../../../Api/FetchHooks";
import { useLocation } from "react-router-dom";
import Page from "../../../../Components/Page";
import AlertComponent from "../../../../Components/AlertComponent";
import {
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import TableComponent from "../../../../Components/TableComponent";
import { AllInbox } from "@mui/icons-material";
import { formatDate } from "../../../../utils/helpers";
import UseServerTable from "../../../../Hooks/UseServerTable";

const Messages = ({ user, showHeader }) => {
  const location = useLocation();
  const loggedInUser = useSelector((state) => state.auth.user);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [messages, setMessages] = useState([]);

  // const [loading, response, request] = FetchHook();

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // const fetchData = useCallback(async () => {
  //   if (user?.msisdn) {
  //     await request({ url: `/sms_logs?filter_value=${user.msisdn}` });
  //   }
  // }, [user, request]);

  // useEffect(() => {
  //   fetchData();
  // }, [fetchData]);

  // useEffect(() => {
  //   if (response?.data?.Data) setMessages(response.data.Data);
  // }, [response]);

  const { gridProps, error, refresh } = UseServerTable({
    baseUrl: `/sms_logs?filter_value=${user.msisdn}`,
    onSuccess: (data) => {
      setMessages(data.Data);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  const columns = [
    {
      field: "id",
      headerName: "#",
      width: 50,
    },
    {
      field: "origin",
      headerName: "Origin",
      width: 130,
    },
    {
      field: "destination",
      headerName: "Destination",
      width: 130,
    },
    {
      field: "message",
      headerName: "Message",
      flex: 1,
      minWidth: 300,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            width: "100%",
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
    },
    {
      field: "created_on",
      headerName: "Date Sent",
      width: 180,
      valueFormatter: (params) => formatDate(params?.value),
    },
  ];

  return (
    <Page title={"Messages"} showHeader={showHeader}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Card>
        <CardHeader
          title={
            <>
              {showHeader === false && (
                <Typography variant="h6">Messages</Typography>
              )}
            </>
          }
        />
        <CardContent>
          {messages && messages.length > 0 ? (
            <>
              <TableComponent
                data={messages}
                // columns={loggedInUser.role === "admin" ? columns : custCols}
                columns={columns}
                sortModel={[
                  {
                    field: "last_updated_on",
                    sort: "desc",
                  },
                ]}
                getRowHeight={() => "auto"}
                {...gridProps}
              />
            </>
          ) : gridProps.loading ? (
            <Grid display={"flex"} justifyContent={"center"}>
              <CircularProgress />
            </Grid>
          ) : (
            <Grid
              container
              display={"flex"}
              direction={"column"}
              alignContent={"center"}
              justifyContent={"center"}
            >
              <AllInbox color="error" sx={{ mx: "auto", fontSize: 80 }} />
              <Typography>No recent messages</Typography>
            </Grid>
          )}
        </CardContent>
      </Card>
    </Page>
  );
};

export default Messages;
